module.exports = __webpack_public_path__ + "img/luggage_big.4526d8eb.png";